export function currentUrlToParams (key = null) {
  const paramsUrl = (window.location.href).split('?')
  if (paramsUrl.length < 2) return key ? null : {}
  const paramsArr = paramsUrl[1].split('&')
  const paramsData = {}
  paramsArr.forEach(r => {
    const data = r.split('=')
    paramsData[data[0]] = data[1]
  })
  if (key) return paramsData.hasOwnProperty(key) ? paramsData[key] : null
  return paramsData
}

export function clone (obj) {
  const strData = JSON.stringify(obj)
  return JSON.parse(strData)
}

/**
 * 重置对象参数
 * @params -> Object
 * @arg = Array => []
 * @arg = Boolean => false
 * @arg = Number => null
 * @arg = String => ''
 * */
export function resetArgs (args, def = {}) {
  for (const key in args) {
    if (def.hasOwnProperty(key)) {
      args[key] = def[key]
    } else {
      if (Array.isArray(args[key])) args[key] = []
      if (typeof args[key] === 'string') args[key] = ''
      if (typeof args[key] === 'number') args[key] = null
      if (typeof args[key] === 'boolean') args[key] = false
    }
  }
}

/**
 *
 * @param obj
 * @param row
 */
export function fillerLeft (obj, row = {}) {
  for (const key in obj) {
    if (row.hasOwnProperty(key)) {
      obj[key] = row[key]
    }
  }
}

export function Scheduler () {
  this.maxCount = 2 /* 同时上传数量 */
  const list = [] /* promise列表 */
  let tempRunIndex = 0
  this.add = function (promiseCreator) {
    list.push(promiseCreator)
    // console.log(list,'promiseCreatorpromiseCreator')
  }
  this.taskStart = function () {
    for (let i = 0; i < this.maxCount; i++) {
      request.bind(this)()
    }
  }

  function request () {
    if (!list || !list.length || tempRunIndex >= this.maxCount) return
    tempRunIndex++
    list.shift()().then(() => {
      tempRunIndex--
      request.bind(this)()
    })
  }
}
